import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Weather from '../components/Weather'
import { withErrorBoundary } from '../errors/ErrorBoundary'

class WeatherContainer extends PureComponent {
  render () {
    const { weather } = this.props

    return <Weather weather={weather} />
  }
}

const mapStateToProps = state => {
  return {
    weather: state.weather
  }
}

export default withErrorBoundary(connect(mapStateToProps, null)(WeatherContainer))



// WEBPACK FOOTER //
// ./src/containers/WeatherContainer.js